import React from "react";
import AttorneyInformationBase from "../../../../features/bonds/shared/components/AttorneyInformationBase";
import { HISTORIC_ATTORNEY_INFO_CONFIG } from "../historicAttorneyConfig";
import { HISTORIC_DATA_UPDATE_ERRORS } from "./historicCreationSharedPropTypes";

const VAHistoricAttorneyInformationForm = ({ data, updateData, errors }) => (
  <AttorneyInformationBase
    cfg={HISTORIC_ATTORNEY_INFO_CONFIG.va}
    data={data}
    updateData={updateData}
    errors={errors}
    isGuest={false}
  />
);

VAHistoricAttorneyInformationForm.propTypes = HISTORIC_DATA_UPDATE_ERRORS;

export default VAHistoricAttorneyInformationForm;
